<template>
    <div :id="'pass-' + question_index" v-if="visible">
        <div class="d-flex justify-start">
            <span class="text-left text-body-1 primary--text font-weight-medium"
                >{{ question_index + 1 }}. {{ question.content }}</span
            >
        </div>
        <ul
            class="options d-flex flex-column justify-center pa-0"
            v-if="question.surveyquestionanswers.length <= 4"
        >
            <li data-cy="answer-item" v-for="(answer, index) of question.surveyquestionanswers" :key="index">
                <input
                    type="radio"
                    :id="'radio-' + question.id + '-' + answer.numberAnswer"
                    :name="'item-' + question.id"
                    :value="answer.numberAnswer"
                />
                <label
                    :for="'radio-' + question.id + '-' + answer.numberAnswer"
                    class="border-radius-1 text-center font-weight-light transition-all my-3"
                    >{{ $utils.upperFirstLetter(answer.content) }}</label
                >
            </li>
        </ul>
        <ul
            v-if="question.surveyquestionanswers.length > 4"
            class="clasificacion d-flex justify-center mt-5 mb-5"
        >
            <li v-for="(answer, index) of question.surveyquestionanswers" :key="index">
                <input
                    type="radio"
                    :id="'radio-' + question.id + '-' + answer.numberAnswer"
                    :name="'item-' + question.id"
                    :value="answer.numberAnswer"
                />
                <label
                    :for="'radio-' + question.id + '-' + answer.numberAnswer"
                    class="d-flex mx-3 justify-content-center flex-column"
                >
                    <i data-cy="answer-item-large" class="fas fa-circle"></i>
                    {{ answer.content }}
                </label>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        question: { type: Object, default: null },
        question_index: { type: [Number, String] },
        visible: { type: Boolean, default: false },
    },
}
</script>

<style lang="css" scoped>
.text-body-1 {
    font-family: 'Patua One', cursive !important;
}

input[type='radio'] {
    display: none;
}

.clasificacion > li > label {
    color: rgb(187, 187, 187);
    text-align: center;
}

.clasificacion > li {
    direction: rtl;
    unicode-bidi: bidi-override;
    list-style: none;
}

.clasificacion {
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
    padding-inline-start: 0;
}

.clasificacion li label:hover,
.clasificacion li label:hover ~ label {
    color: #514773;
}

.clasificacion li input[type='radio']:checked ~ label {
    color: #514773;
}
</style>
